import * as React from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

export interface LinkListTertiaryItemProps {
  link: string;
  title: string;
  iconName?: string;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
}

const LinkListTertiaryItem: React.FC<LinkListTertiaryItemProps> = (props) => {
  const {
    link,
    title,
    iconName = 'chevron_right',
    as: Component = 'li',
    className,
  } = props;

  const classes = c('LinkList__TertiaryItem', className);

  return (
    <Component className={classes}>
      <CoreLink href={link}>
        <Icon name={iconName} />
        <span className="LinkList__TertiaryItem__title">{title}</span>
      </CoreLink>
    </Component>
  );
};

export default LinkListTertiaryItem;
